import Component from '@glimmer/component'
import { action } from '@ember/object'
import { on } from '@ember/modifier'
import { not } from 'ember-truth-helpers'
import t from 'ember-intl/helpers/t'

export interface ReviewSummarySignature {
  Element: HTMLElement
  Args: {
    count: number
    avgRating?: number
    onClick?: () => void
  }
}

export default class ReviewSummary extends Component<ReviewSummarySignature> {
  get formattedRating(): string {
    return this.args.avgRating ? this.args.avgRating.toFixed(1) : '—'
  }

  @action
  handleClick(): void {
    this.args.onClick?.()
  }

  <template>
    {{! @glint-ignore: wait until we can't declare custom elements in glint }}
    <il-tag variant='gray' size='small' class={{if @onClick 'cursor-pointer'}} data-testid='review-summary' ...attributes>
      <button
        type='button'
        disabled={{not @onClick}}
        class='enabled:cursor-pointer disabled:cursor-default flex items-center gap-2 border-none bg-transparent p-0'
        {{on 'click' this.handleClick}}
      >
        <span class='flex items-center gap-1'>
          <span class='text-bold-para-14 text-neutrals-300'>{{this.formattedRating}}</span>
          <span class='text-[hsla(45,100%,51%,1)]' aria-hidden='true'>{{t 'booking.reviews.star-symbol'}}</span>
        </span>
        <span class='h-4 w-px bg-neutrals-100'></span>
        <span class='text-reg-para-12 text-neutrals-300 {{if @onClick "underline"}}'>{{t 'booking.reviews.summary-count' count=@count}}</span>
      </button>
    </il-tag>
  </template>
}
